import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import { userTransactionRepository } from "./user-transactions.repository";
import { UserTransaction } from "./types/user-transaction.entity";
import { FilterQuery } from "@utils/util.types";
import { refundSessionByPercentage, UsersTransactionsFilter } from "./types";
import { userRepository } from "../users/repositories/user.repository";
import { callFunctionSafe } from "src/firebase/functions";
import { sessionRepository } from "../sessions/session.repsoitory";

export const buildTransactionWhere = async (
  where: UsersTransactionsFilter
): Promise<FilterQuery<UserTransaction>["where"]> => {
  let q: FilterQuery<UserTransaction>["where"] = {};
  console.log(where);
  if (where.bookingId && where.sessionId) {
    q = { $or: [{ "metadata.bookingId": where.bookingId }, { "metadata.sessionId": where.sessionId }] };
  } else if (where.bookingId) {
    q["metadata.bookingId"] = where.bookingId;
  } else if (where.sessionId) {
    q["metadata.sessionId"] = where.sessionId;
  } else if (where.userIdentifier) {
    const user = await userRepository.getByEmailOrPhoneNumber(where.userIdentifier);
    q.userId = user?.id ?? where.userIdentifier;
  } else if (where.status) {
    q.status = where.status;
  } else if (where.type) {
    q.type = where.type;
  } else if (where.currency) {
    q.currency = where.currency;
  }

  return q;
};

const usersTransactionsService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getUsersTransactions: builder.query<UserTransaction[], { where: UsersTransactionsFilter; offset?: string }>({
      queryFn: async ({ where, offset }) => {
        const filterQuery = await buildTransactionWhere(where);
        return executeQuery(() =>
          userTransactionRepository.find({ where: filterQuery, offset, orderBy: ["createdAt", "desc"] })
        );
      },
      providesTags: ["UserTransaction"],
    }),
    countUsersTransactions: builder.query<number, { where: UsersTransactionsFilter }>({
      queryFn: async ({ where }) => {
        const filterQuery = await buildTransactionWhere(where);
        return await executeQuery(() => userTransactionRepository.count(filterQuery));
      },
      providesTags: ["UserTransaction"],
    }),
    refundSessionTransaction: builder.mutation<void, refundSessionByPercentage>({
      queryFn: async ({ bookingId, learnerId, percentage, sessionId }) => {
        const resolvedSessionId = sessionId ?? (await sessionRepository.findSessionByBookingId(bookingId))?.id;

        return callFunctionSafe("refundSessionToLearnerByPercentage", {
          sessionId: resolvedSessionId,
          percentage: percentage,
          learnerId: learnerId,
        });
      },
      invalidatesTags: ["UserTransaction"],
    }),
  }),
});

export const { useGetUsersTransactionsQuery, useCountUsersTransactionsQuery, useRefundSessionTransactionMutation } =
  usersTransactionsService;
